export default __webpack_public_path__ + "static/media/DE.f0f7dd41.svg";